import { useAuth0 } from "@auth0/auth0-react";
import { Link } from "react-router-dom";
import React from "react";
import Button from "react-bootstrap/Button";

const Steps = () => {
  const { isAuthenticated, loginWithRedirect } = useAuth0();

  const href = window.location.href;
  const url = href.substring(0, href.length - 1);

  return (
    <></>
    // <>
    //   <Step number="1">
    //     <p className="card-docs-description">
    //       <a
    //         target="_blank"
    //         rel="noopener noreferrer"
    //         href="https://auth0.com/signup"
    //       >
    //         Sign up for a <strong>free</strong> Auth0 account.
    //       </a>
    //     </p>
    //   </Step>
    //   <Step number="2">
    //     <p className="card-docs-description">Create an Auth0 Application:</p>
    //     <p className="card-docs-description">
    //       Open the{" "}
    //       <a
    //         target="_blank"
    //         rel="noopener noreferrer"
    //         href="https://manage.auth0.com/#/applications"
    //       >
    //         Applications
    //       </a>{" "}
    //       section of the Auth0 dashboard.
    //     </p>
    //     <p className="card-docs-description">
    //       Click <strong>Create Application</strong>.
    //     </p>
    //     <p className="card-docs-description">
    //       Give it a <strong>Name</strong>, such as{" "}
    //       <strong>Auth0 React Quickstart</strong>.
    //     </p>
    //     <p className="card-docs-description">
    //       Choose <strong>Single Page Web Applications</strong> as the{" "}
    //       <strong>application type</strong>.
    //     </p>
    //     <p className="card-docs-description">
    //       Click <strong>Create</strong>.
    //     </p>
    //   </Step>
    //   <Step number="3">
    //     <p className="card-docs-description">
    //       Update the following fields in your Auth0 Application{" "}
    //       <strong>Settings</strong>:
    //     </p>
    //     <div className="fields">
    //       <div className="card-docs-description field">
    //         <strong className="field__key">Allowed Callback URLs</strong>
    //         <pre className="field__value">{url}</pre>
    //       </div>
    //       <div className="card-docs-description field">
    //         <strong className="field__key">Allowed Logout URLs</strong>
    //         <pre className="field__value">{url}</pre>
    //       </div>
    //       <div className="card-docs-description field">
    //         <strong className="field__key">Allowed Web Origins</strong>
    //         <pre className="field__value">{url}</pre>
    //       </div>
    //     </div>
    //     <p className="card-docs-description">
    //       Scroll to the bottom and click <strong>Save Changes</strong>.
    //     </p>
    //   </Step>
    //   <Step number="4">
    //     <p className="card-docs-description">
    //       Create a <code>.env</code> file under the root project directory with
    //       the following:
    //     </p>
    //     <CodeBox>
    //       {`REACT_APP_AUTH0_DOMAIN=YOUR-AUTH0-DOMAIN`}
    //       <br />
    //       {`REACT_APP_AUTH0_CLIENT_ID=YOUR-AUTH0-CLIENT-ID`}
    //     </CodeBox>
    //     <p className="card-docs-description">
    //       Replace <code>YOUR-AUTH0-DOMAIN</code> with the value of{" "}
    //       <strong>Domain</strong> from the Auth0 Application Settings.
    //     </p>
    //     <p className="card-docs-description">
    //       Replace <code>YOUR-AUTH0-CLIENT-ID</code> with the value of{" "}
    //       <strong>Client ID</strong> from the Auth0 Application Settings.
    //     </p>
    //   </Step>
    //   <Step number="5">
    //     <p className="card-docs-description">
    //       {isAuthenticated ? (
    //         <span>You are already logged in. Proceed to next step!</span>
    //       ) : (
    //         <button onClick={loginWithRedirect} className="btn btn-success">
    //           Login
    //         </button>
    //       )}
    //     </p>
    //   </Step>
    //   <Step number="6">
    //     <p className="card-docs-description">
    //       <span>
    //         Access <Link to="/profile">guarded route</Link>.
    //       </span>
    //       <strong>
    //         {!isAuthenticated && <span>You must logged in to do this.</span>}
    //       </strong>
    //     </p>
    //   </Step>
    //   <div className="try-banner">
    //     <span>Don't have an account yet?</span>
    //     <a
    //       target="_blank"
    //       rel="noopener noreferrer"
    //       href="https://auth0.com/signup"
    //       className="btn btn-success btn-lg"
    //     >
    //       Try Auth0 for Free
    //     </a>
    //   </div>
    // </>
  );
}

const Header = () => {

  return (
    <section className="jumbotron">
      <img
        src={`${process.env.REACT_APP_AWS_LOCATION}/header/header-logo.png`}
        alt="Business Butler"
      />
      <h1>Business Butler Intranet Services</h1>
      <p>
        Select one of the areas below to be redirected to the relevent edit pages.
      </p>
      {/* <Link to="/services">
        <Button  className="btn btn-primary">
          services
        </Button>
      </Link>
      <Link to="/blogs">
        <Button  className="btn btn-primary">
          Blogs
        </Button>
      </Link>
      <Link to="/businessguides">
        <Button  className="btn btn-primary">
          Business Guides
        </Button>
      </Link> */}
      {/* <Link to="/experts">
        <Button  className="btn btn-primary">
          Experts
        </Button>
      </Link>
      <Link to="/auth">
        <Button  className="btn btn-primary">
          Auth
        </Button>
      </Link> */}
      <Link to="/events">
        <Button  className="btn btn-primary">
          Events
        </Button>
      </Link>
      <Link to="/reports">
        <Button  className="btn btn-primary">
          Reports
        </Button>
      </Link>
      {/* <Link to="/keywords">
        <Button  className="btn btn-primary">
          Search Keywords
        </Button>
      </Link> */}
      <Link to="/member-offers">
        <Button  className="btn btn-primary">
          Member Offers
        </Button>
      </Link>
      <Link to="/emailcreator">
        <Button  className="btn btn-primary">
          Email Creator
        </Button>
      </Link>
      <Link to="/members">
        <Button  className="btn btn-primary">
          Members
        </Button>
      </Link>
      <Link to="/credits">
        <Button  className="btn btn-primary">
          Credits
        </Button>
      </Link>
      <a href="https://businessbutleruk.sharepoint.com/:f:/s/FaBE/Et5seuXtJH9PvivbIbzE4jQB4ltkZ9r1d942w56DBmEP_A?e=fGlBno">
        <Button>
          Processes
        </Button>
      </a>
      {/* <Link to="/graduates">
        <Button  className="btn btn-primary">
          Graduates
        </Button>
      </Link> */}
    </section>
  );
};

const HomeView = () => {
  return (
    <>
      <Header />
      <Steps />
    </>
  );
};

export default HomeView;
